import { coreApi } from '@cp/shared/api/core';
import { ApiRouteBody } from '@common/api/routeBody';
import { ApiRoute } from '@common/api/route';
import { generateApiUrl } from '@common/api/configure';
import { apiRouteMethodDict } from '@common/api/routeMethod';

export const currentClientNotificationApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    subscribeToWebpushNotifications: builder.mutation<void, ApiRouteBody[ApiRoute.ClientNotificationsWebpushSubscribe]>({
      query: (body) => ({
        url: generateApiUrl(ApiRoute.ClientNotificationsWebpushSubscribe),
        method: apiRouteMethodDict[ApiRoute.ClientNotificationsWebpushSubscribe],
        body,
      }),
    }),

    unsubscribeFromWebpushNotifications: builder.mutation<void, ApiRouteBody[ApiRoute.ClientNotificationsWebpushUnsubscribe]>({
      query: (body) => ({
        url: generateApiUrl(ApiRoute.ClientNotificationsWebpushUnsubscribe),
        method: apiRouteMethodDict[ApiRoute.ClientNotificationsWebpushUnsubscribe],
        body,
      }),
    }),

    subscribeToPushNotifications: builder.mutation<void, ApiRouteBody[ApiRoute.ClientNotificationsPushSubscribe]>({
      query: (body) => ({
        url: generateApiUrl(ApiRoute.ClientNotificationsPushSubscribe),
        method: apiRouteMethodDict[ApiRoute.ClientNotificationsPushSubscribe],
        body,
      }),
    }),
  }),
});
